import { useRef } from 'react';
import { ClickAwayListener, Divider, useTheme } from '@mui/material';
import { ChevronDownIcon } from 'app/components/Icons';
import { TextM } from 'app/components/typography';
import {
  IconArea,
  PopoverItem,
  PopoverItemContainer,
  SearchFilterSelectContainer,
} from './styles';
import { TFilterItems } from '../SearchFilter';
import { Popover } from 'app/components/Popover';

export interface ISearchFilterSelectProps {
  handleClose: () => void;
  isOpen: boolean;
  handleSelectFilter: (elementValue: TFilterItems) => void;
  handleOpen: () => void;
  selectedElement?: string | undefined;
  filterItems: TFilterItems[];
}

const SearchFilterSelect = ({
  filterItems,
  isOpen,
  selectedElement,
  handleClose,
  handleSelectFilter,
  handleOpen,
}: ISearchFilterSelectProps) => {
  const theme = useTheme();
  const selectBoxRef = useRef<HTMLDivElement>(null);

  const handleCloseSearchFilterSelect = () => {
    handleClose();
  };

  const handleSelectSearchFilter = (elementValue: TFilterItems) => {
    handleSelectFilter(elementValue);
    handleClose();
  };

  const handleOpenSearchFilter = () => {
    handleOpen();
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <>
        <SearchFilterSelectContainer
          ref={selectBoxRef}
          onClick={handleOpenSearchFilter}
        >
          <TextM style={{ textOverflow: 'ellipsis', maxWidth: '120px' }}>
            {selectedElement ? selectedElement : filterItems?.[0].name}
          </TextM>
          <IconArea>
            <ChevronDownIcon
              color={theme.palette.brand.primary.base as string}
            />
          </IconArea>
        </SearchFilterSelectContainer>
        <Popover
          open={isOpen}
          anchorEl={selectBoxRef.current}
          onClose={handleCloseSearchFilterSelect}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          sx={{
            '& .MuiPopover-paper	': {
              marginTop: '26px',
              marginLeft: '-10px',
              minWidth: '160px',
              boxShadow: '0px 18px 25px rgba(0, 21, 33, 0.14)',
              backgroundColor: '#FDFDFD',
              border: '1px solid #EDEDED',
              borderRadius: '20px',
            },
          }}
        >
          <PopoverItemContainer>
            {filterItems.map((item, idx) => (
              <div key={idx}>
                <PopoverItem
                  onClick={() => handleSelectSearchFilter(item)}
                  key={idx}
                >
                  <TextM weight="Medium">{item.name}</TextM>
                </PopoverItem>
                <Divider />
              </div>
            ))}
          </PopoverItemContainer>
        </Popover>
      </>
    </ClickAwayListener>
  );
};

export default SearchFilterSelect;
